import { ColDef } from "ag-grid-community";
import { AzVmssVmProviderStatusCellRenderer } from "./AzVmssVmProviderStatusCellRenderer";
import { jiraIssuesColumnDef } from "../../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../../common/tagsColumnDef";
import { smartTagsColumnDef } from "../../common/smartTagsColumnDef";
import { resourceTotalSpendColumnDef } from "../../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../../common/getResourceCreationTimeColumnDef";
import { forecastedEOMColumnDef } from "../../common/forecastedEOMColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const azVmssVmColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Instance Name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_vmss_vm"),

  resourceTotalSpendColumnDef,

  {
    field: "resource.provider_status",
    headerName: "Status",
    cellRenderer: AzVmssVmProviderStatusCellRenderer,
  },

  getResourceCreationTimeColumnDef("Launch time"),

  { field: "resource.size", headerName: "Machine Size" },

  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
